<mat-spinner mode="indeterminate" value=100 *ngIf="isLoading" class="spinner"></mat-spinner>
